import Vue from 'vue';
import Vuex, { ActionTree, MutationTree, Action, Store, MutationPayload } from 'vuex';
import middlewarePlugin from '../nmb/middleware';
import notice from './moudules/notice';
import experience from './moudules/experience';
import document from './moudules/document';
import feedback from './moudules/feedback';
import globalSearch from './moudules/globalSearch';
import onlineClass from './moudules/onlineClass';
import board from './moudules/board';
import contacts from './moudules/contacts';
import studymap from './moudules/studymap';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    notice,
    experience,
    document,
    feedback,
    globalSearch,
    onlineClass,
    board,
    contacts,
    studymap
  },
  plugins: [middlewarePlugin]
});
